export default __webpack_public_path__ + "static/media/future-scenario-planning.9bdbc3a2.svg";